import { pagingSettings } from '../../../utils/GridPagingUtils';
import ClaimReviewListPageActionTypes from '../actions/claim-review-list-page-action-types';

const initialState = {
  loading: false,
  claims: null,
  cancelToken: null,
  skip: pagingSettings.paging.skip,
  take: pagingSettings.paging.take,
  total: 0,
  filter: null,
  sorting: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ClaimReviewListPageActionTypes.LOAD_CLAIM_REVIEW_LIST_START:
      return {
        ...state,
        loading: true
      };
    case ClaimReviewListPageActionTypes.LOAD_CLAIM_REVIEW_LIST_END:
      return {
        ...state,
        loading: false,
        claims: action.payload?.claims,
        total: action.payload?.total,
        skip: action.payload?.skip,
        take: action.payload?.take
      };
    case ClaimReviewListPageActionTypes.FILTER_CLAIM_REVIEW_LIST:
      return {
        ...state,
        filter: action.payload,
        skip: initialState.skip,
        take: initialState.take
      };
    case ClaimReviewListPageActionTypes.SORT_CLAIM_REVIEW_LIST:
      return {
        ...state,
        sorting: action.payload
      };
    default:
      return state;
  }
};
